module.exports = __webpack_public_path__ + "img/17-avatar male.102f8453.png";